import React from "react"

import ContentLoaderLines from "./ContentLoaderLines"

export default props => <ContentLoaderLines isFetching={true} {...props} />
